import mitt from 'mitt';

const eventBus = mitt();

export default {
  $on: (...args) => eventBus.on(...args),
  $off: (...args) => eventBus.off(...args),
  $emit: (...args) => eventBus.emit(...args),
};
